import Vue from 'vue';

function clearUser(state) {
	Vue.set(state, 'token', null);
	Vue.set(state, 'user', null);
}

function setToken(state, token) {
	Vue.set(state, 'token', token);
}

function setUser(state, user) {
	Vue.set(state, 'user', user);
}

function showSnackBar(state, snackbar) {
	Vue.set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	Vue.set(state.appConfig, 'isLoading', value);
}

const methods = {
	clearUser,
	setToken,
	setUser,
	showSnackBar,
	toggleLoading,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/mutations.js